import React from 'react';

import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Collapse } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextHeader1 } from 'uiToolkitV1/Typography';

function ExpandedCFBarChart({ children, isOpen = false, onClose = () => {} }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={{ maxW: '90%', m: 'auto' }}>
        <Box display="flex">
          <ModalHeader sx={{ p: '32px 40px', flex: '1 1 auto' }}>
            <TextHeader1 bold lineHeight="1.34">
              Feedback Shared and Received
            </TextHeader1>
          </ModalHeader>
          <Button
            style={{ flex: '0 0 auto', padding: '36px 40px' }}
            variant="tertiary"
            EndIcon={Collapse}
            onClick={onClose}
          />
        </Box>

        <ModalBody sx={{ p: '32px 40px' }}>
          <StyledChartContainer> {children} </StyledChartContainer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ExpandedCFBarChart;

const StyledChartContainer = styled.div`
  height: 60vh;
`;
